import HandbookReducer from './HandbookReducer';
export default HandbookReducer;
